'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@radix-ui/react-tooltip/dist/index.cjs');
var React = require('react');
var Typography_web = require('../Typography/Typography.web.cjs');
var Tooltip_web_styles = require('./Tooltip.web.styles.cjs');

/**
 * The Tooltip component wraps around a trigger element and shows a tooltip when hovered or focused.
 */ const Tooltip = ({ enterDelay = 100, isTooltipHidden, children, tooltipContent, hideArrow, isOpen, isTriggerWidth, side = "bottom", align = "center" })=>{
    const contentStyles = [
        Tooltip_web_styles.tooltipContent,
        isTriggerWidth && Tooltip_web_styles.triggerWidthContent
    ];
    const renderArrow = ()=>{
        if (hideArrow) {
            return null;
        }
        return /*#__PURE__*/ jsxRuntime.jsx(index.Arrow, {
            css: Tooltip_web_styles.arrow,
            width: 18,
            height: 9
        });
    };
    const getTabIndex = ()=>{
        const childrenHasButton = React.Children.toArray(children).some((child)=>{
            if (typeof child === "object" && "type" in child) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return child.type?.displayName === "Button";
            }
            return false;
        });
        return childrenHasButton ? undefined : 0;
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
            children: /*#__PURE__*/ jsxRuntime.jsxs(index.Content, {
                css: contentStyles,
                className: "TooltipContent",
                sideOffset: 2,
                side: side,
                align: align,
                collisionPadding: 16,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        children: tooltipContent
                    }),
                    renderArrow()
                ]
            })
        });
    };
    if (isTooltipHidden) return React.Children.only(children);
    return /*#__PURE__*/ jsxRuntime.jsx(index.Provider, {
        delayDuration: enterDelay,
        children: /*#__PURE__*/ jsxRuntime.jsxs(index.Root, {
            open: isOpen,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(index.Trigger, {
                    asChild: true,
                    children: /*#__PURE__*/ jsxRuntime.jsx("div", {
                        role: "status",
                        tabIndex: getTabIndex(),
                        "data-testid": "trigger",
                        css: Tooltip_web_styles.triggerWrapper,
                        children: children
                    })
                }),
                renderContent()
            ]
        })
    });
};

exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.web.cjs.map
